import type {
  ProductFlagFormValues,
  UpdateOrgProductFlagsRequest,
} from '@/definitions/productFlags'

/**
 * Builds the product flags request body.
 *
 * Written out field by field rather than looped over a list of names, so the
 * compiler checks the set against the endpoint's shape. A flag renamed, added or
 * dropped on the backend then fails the build here, rather than at save time where
 * one unrecognised or missing field rejects the whole request.
 */
export const buildProductFlagsRequest = (
  values: ProductFlagFormValues
): UpdateOrgProductFlagsRequest => ({
  kno2_enabled: values.kno2_enabled,
  ecr_vault_enabled: values.ecr_vault_enabled,
  stripe_enabled: values.stripe_enabled,
  stripe_manual_credit_card_enabled: values.stripe_manual_credit_card_enabled,
  single_payment_link_enabled: values.single_payment_link_enabled,
  bulk_payment_link_enabled: values.bulk_payment_link_enabled,
  bulk_claim_export_enabled: values.bulk_claim_export_enabled,
  office_chat_enabled: values.office_chat_enabled,
  eligibility_automation_enabled: values.eligibility_automation_enabled,
  ai_scribe_enabled: values.ai_scribe_enabled,
  ai_agent_scribe_enabled: values.ai_agent_scribe_enabled,
  ai_scanning_enabled: values.ai_scanning_enabled,
  ai_exam_history_enabled: values.ai_exam_history_enabled,
  ai_guidelines_enabled: values.ai_guidelines_enabled,
  ai_file_summary_enabled: values.ai_file_summary_enabled,
  ai_voicemail_transcription_enabled: values.ai_voicemail_transcription_enabled,
  ai_voicemail_analysis_enabled: values.ai_voicemail_analysis_enabled,
  ai_voice_agent_enabled: values.ai_voice_agent_enabled,
  ai_call_transcription_enabled: values.ai_call_transcription_enabled,
  ai_call_analysis_enabled: values.ai_call_analysis_enabled,
  ai_inbound_sms_enabled: values.ai_inbound_sms_enabled,
  capital_os_enabled: values.capital_os_enabled,
  erx_enabled: values.erx_enabled,
  pocketflows_enabled: values.pocketflows_enabled,
  pocketflows_reviews_enabled: values.pocketflows_reviews_enabled,
  pocketflows_event_triggers_enabled: values.pocketflows_event_triggers_enabled,
  twilio_enabled: values.twilio_enabled,
  // Null rather than empty: the endpoint reads null as "no subaccount", and an
  // empty string would be a value that identifies nothing.
  twilio_account_sid: values.twilio_account_sid.trim() || null,
  twilio_voip_enabled: values.twilio_voip_enabled,
})
